import { State } from 'modules';

import { getEnumValues } from 'utils/helper';

import { APIUserOrganization, APIUserRight, APIUserType } from 'types/api';

export const user = (state: State) => state.app?.user;
export const selectedOrganization = (state: State) =>
  state.app?.user?.userOrganizations?.find(it => it.isSelected);

export const userId = (state: State) => state.app?.user?.id;

export const userType = (state: State) => state.app?.user?.userType;

export const organizationId = (state: State) =>
  state.app?.user?.userOrganizations?.find(it => it.isSelected)?.organization
    .id ?? '';

export const currentOrganization = (state: State) =>
  state.app?.user?.userOrganizations?.find(it => it.isSelected)?.organization;

export const organizations = (state: State) =>
  state.app.user?.userOrganizations as APIUserOrganization[];

export const isAppLoaded = (state: State) => state.app.isAppLoaded;
export const userInfoPending = (state: State) => state.app.userInfoPending;
export const userLoginInPending = (state: State) =>
  state.app.userLoginInPending;

export const isNavigationCollapsed = (state: State) =>
  state.app.isNavigationCollapsed;

export const userRegisterPending = (state: State) =>
  state.app.userRegisterPending;

export const isAdminUser = (state: State) => {
  const userType = state.app?.user?.userOrganizations?.find(
    it => it.isSelected,
  )?.userType;

  return userType === APIUserType.Admin || userType === APIUserType.SuperAdmin;
};

export const organizationUserType = (state: State) => {
  const userType = state.app?.user?.userOrganizations?.find(
    it => it.isSelected,
  )?.userType;
  return userType ?? APIUserType.User;
};

export const organizationUserRights = (state: State) => {
  const organization = state.app?.user?.userOrganizations?.find(
    it => it.isSelected,
  );

  const userType = organization?.userType;
  const userRights = organization?.userRights;

  if (!userType) {
    return [];
  }

  // A super admin viewing an external organization (synthetic membership) has
  // full access, same as an organization admin.
  return userType == APIUserType.Admin || userType == APIUserType.SuperAdmin
    ? getEnumValues(APIUserRight)
    : userRights?.map(it => it.right);
};

export const isSuperAdmin = (state: State) =>
  state.app?.user?.userType === APIUserType.SuperAdmin;

export const updateAvatarPending = (state: State) =>
  state.app.updateAvatarPending;

export const updateSelfInfoPending = (state: State) =>
  state.app.updateSelfInfoPending;
